import Vue from 'vue'
import Router from 'vue-router'
import home from "@/view/home/home"
import productCenter from "@/view/productCenter/productCenter.vue"
import znProduct from "@/view/productCenter/components/znProduct.vue"
import mlyProduct from "@/view/productCenter/components/mlyProduct.vue"
import solution from "@/view/solution/solution.vue"
import aboutUs from "@/view/aboutUs/aboutUs.vue"
import experience from "@/view/experience/experience.vue"

Vue.use(Router)

export default new Router({
    mode: 'history',
    routes: [

        {
            path: '*',
            redirect: {
                name: 'home'
            }
        },
        {
            path: '/',
            redirect: {
                name: 'home'
            }
        },
        {
            path: '/home',
            name: 'home',
            component: home
        },
        {
            path: '/product',
            name: 'productCenter',
            component: productCenter,
            children: [{
                    path: 'zn',
                    name: 'zn',
                    component: znProduct
                },
                {
                    path: 'mly',
                    name: 'mly',
                    component: mlyProduct
                },
                {
                    path: 'crm',
                    name: 'crm',
                },
            ]
        },
        {
            path: '/solution',
            name: 'solution',
            component: solution
        },
        {
            path: '/aboutUs',
            name: 'aboutUs',
            component: aboutUs
        },
        {
            path: '/experience',
            name: 'experience',
            component: experience
        },
    ]
})

const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}


// WEBPACK FOOTER //
// ./src/router/index.js